import type { ContactCard } from "./types";

export const CONTACT_EMAIL_MAX = 254;

const EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
const PHONE = /^\+?[0-9 ()-]+$/;

/** A trimmed email address, or null when the value is not one. */
export function parseContactEmail(v: unknown): string | null {
    if (typeof v !== "string") return null;
    const s = v.trim();
    return s.length <= CONTACT_EMAIL_MAX && EMAIL.test(s) ? s : null;
}

/** A trimmed phone number of 7 to 15 digits, with an optional leading + and spaces, brackets or dashes; else null. */
export function parsePhone(v: unknown): string | null {
    if (typeof v !== "string") return null;
    const s = v.trim().replace(/\s+/g, " ");
    if (!PHONE.test(s)) return null;
    const digits = s.replace(/\D/g, "").length;
    return digits >= 7 && digits <= 15 ? s : null;
}

/** The ways to reach someone, as links, email first. Empty when there are none. */
export function contactLinks(card: ContactCard): { kind: "email" | "phone"; label: string; href: string }[] {
    const links: { kind: "email" | "phone"; label: string; href: string }[] = [];
    if (card.email) links.push({ kind: "email", label: card.email, href: `mailto:${card.email}` });
    if (card.phone) links.push({ kind: "phone", label: card.phone, href: `tel:${card.phone.replace(/[^\d+]/g, "")}` });
    return links;
}

/** A contact from stored fields that may be missing or malformed, keeping only the parts that parse. */
export function contactCard(name: string, email: unknown, phone: unknown): ContactCard {
    return { name, email: parseContactEmail(email), phone: parsePhone(phone) };
}
